import React, { useEffect } from "react";
import { useSelector} from "react-redux";
import { Badge, CustomDataTable, PopupMenu } from "../../../components";
import { DashboardRow } from "../../../styles/admin/CardBox.styled";
import { getTeamMembersBadge } from "../../../misc/helpers";
import { DetailsButton, Flex } from "../../../styles/admin/DetailsPanel";
import { LoadingBar } from "../../../components/loading_bar/LoadingBar";
import { getSubscriptionPlans, deleteSubscriptionPlan, reset } from "../../../features/subscription_plans/subscriptionPlanSlice";
import { Routes } from "../../../core/routes/apiRoutes";
import { Link, useNavigate } from "react-router-dom";
import useResource from "../../../core/hooks/useResource";
import { AppRoutes } from "../../../core/routes/routes";

const perPage = 30;

function SubscriptionPlans() {
	const navigate = useNavigate();
	const onUpdate = (ref) => {
		navigate(AppRoutes.updateSubscriptionPlanUrl+"/"+ref);
	};

	const prepareTableData = (response, page) => {
		var rows = [];
		const tempData = response.data;

		for (let i = 0; i < tempData.length; i++) {
			var item = {
				id: i + 1 + page,
				sn: i + 1 + page,
				name: tempData[i].name,
				description: tempData[i].description,
				period: tempData[i].period,
				amount: tempData[i].subscription_value,
				status: tempData[i].is_enabled?'active':'disabled',
				slug: tempData[i].slug,
			};

			rows.push(item);
		}

		return rows;
	};

	const { onPrevPage, onNextPage, page, tableData, ref, isLoading, onDelete} =
		useResource({
			selector: useSelector((state) => state.subscriptionPlan),
			perPage: perPage,
			getReducer: getSubscriptionPlans,
			resetReducer: reset,
			deleteReducer: deleteSubscriptionPlan,
			renderTableData: prepareTableData,
			routes: {
				getRoute: Routes.getSubscriptionPlansUrl,
			},
		});

	const actions = [
		{ title: "Update", onClick: onUpdate },
		{ title: "Delete", onClick: onDelete },
	];

	const columns = [
		{
			field: "sn",
			headerName: "S/N",
			minWidth: 10,
			flex: 1,
		},
		{
			field: "name",
			headerName: "Name",
			minWidth: 100,
			flex: 2,
		},

		{
			field: "description",
			headerName: "Description",
			minWidth: 100,
			flex: 2,
		},
		{
			field: "period",
			headerName: "Period",
			minWidth: 100,
			flex: 2,
		},
		{
			field: "amount",
			headerName: "Amount",
			minWidth: 100,
			flex: 2,
		},
		{
			field: "status",
			headerName: "Status",
			minWidth: 100,
			flex: 2,
			sortable: false,
			renderCell: (params) => {
				const badge = getTeamMembersBadge(params.row.status);
				return <Badge {...badge.badgeType}>{badge.badgeText}</Badge>;
			},
			disableClickEventBubbling: true,
		},
		{
			field: "actions",
			headerName: "",
			minWidth: 100,
			flex: 1,
			sortable: false,
			renderCell: (params) => {
				return <PopupMenu id={params.row.slug} options={actions} />;
			},
			disableClickEventBubbling: true,
		},
	];

	useEffect(() => {
		document.title = "Subscription Plans - Greymate Care Admin";
	}, []);

	return (
		<>
			<LoadingBar ref={ref} shadow={true} />
			<Flex justifyContent="space-between" alignItems="center">
				<h1>Subscription Plans</h1>
				<DetailsButton as={Link} to="create" $primary>
					Create Subscription Plan
				</DetailsButton>
			</Flex>

			<DashboardRow>
				<CustomDataTable
					disableSelectionOnClick
					pageSize={perPage}
					pagination="false"
					rowsPerPageOptions={[]}
					loading={isLoading}
					columns={columns}
					rows={tableData}
					hideFooter={true}
					prev={onPrevPage}
					next={onNextPage}
					currentPage={page}
					searchType="local"
					removePagination={true}
				/>
			</DashboardRow>
		</>
	);
}

export default SubscriptionPlans;
